import React from 'react'
import Layout from './Layout'

export default function PremiumLayout (props) {
  return (
    <Layout
      showShortcuts={false}
      showPremium={false}
      {...props}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/layout/PremiumLayout.jsx